import React from 'react';
import { Translation } from 'react-i18next';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const ACTIVE_STATUS_OPTIONS = [
  {
    key: true,
    value: 1,
    text: <Translation>{t => t('active')}</Translation>,
  },
  {
    key: false,
    value: 0,
    text: <Translation>{t => t('inactive')}</Translation>,
  },
];

const ActiveFilter = () => (
  <IconFilter
    hasApplyButton
    name="isActive"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={ACTIVE_STATUS_OPTIONS}
  />
);

export default ActiveFilter;
